import { VisuallyHidden } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';
import type { GetServerSidePropsContext } from 'next/types';
import qs from 'query-string';
import { getCdnTranslationProps } from '../../utils/server/i18n/getCdnTranslationProps';

import {
  API_ENDPOINT,
  type ClientApiV1CoursesIdSimpleResponse,
  fetchClientApiV1CoursesIdSimple,
} from '../../../resources/@types/courseSchema';
import CertificateLayout from '../../components/layout/CertificateLayout';
import { Certificate, getCertificateQueries } from '../../components/pages/certificate/Certificate';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const locale = context.locale as string;

  try {
    const params = getCertificateQueries(context.query.id as string);
    const courseResponse = await fetchClientApiV1CoursesIdSimple(
      qs.stringifyUrl({
        url: API_ENDPOINT.CLIENT_V1_COURSES_ID_SIMPLE(String(params.courseId)),
      }),
    );

    return {
      props: {
        ...(await getCdnTranslationProps(locale, ['common'])),
        course: courseResponse.data || null,
      },
    };
  } catch (_error) {
    return {
      props: {
        ...(await getCdnTranslationProps(locale, ['common'])),
        course: null,
      },
    };
  }
}

interface Props {
  course: ClientApiV1CoursesIdSimpleResponse['data'] | null;
}

export default function CertificatePage({ course }: Props) {
  const { t } = useTranslation();

  return (
    <CertificateLayout
      courseTitle={course?.title}
      meta={{
        title: '메타_수료증상세_제목',
      }}
    >
      <VisuallyHidden>
        <h1>{t('수료증_상세페이지')}</h1>
      </VisuallyHidden>
      <Certificate />
    </CertificateLayout>
  );
}
